export const tableControls = (t) => [
  { id: "scfControl", type: "text", label: t('company:complianceProgram.dashboard.table.control'), sortable: true },
  { id: "scfDomain", type: "dropdown", label: t('company:complianceProgram.dashboard.table.domain'), sortable: true },
  { id: "controlWeighting", type: "number", label: t('company:complianceProgram.dashboard.table.weight'), sortable: true },
  { id: "status", label: t('company:complianceProgram.dashboard.table.status'), type: "status"},
  { id: "maturity_level", label: t('company:complianceProgram.dashboard.table.maturity'), type: "maturity-level" },
  { id: "actions-view", type: "actions-view", label: "" },
];
